import type { CSSProperties } from 'react';

interface StatusPillProps {
  label: string;
  bg: string;
  fg: string;
  header?: boolean;
}

export const StatusPill = ({ label, bg, fg, header }: StatusPillProps) => (
  <span
    className={header ? 'status-pill status-pill--header' : 'status-pill'}
    style={{ '--pill-bg': bg, '--pill-fg': fg } as CSSProperties}
  >
    {label}
  </span>
);
